/*
 * @Description: 
 * @Author: Rfan
 * @Date: 2020-01-14 11:45:20
 * @LastEditTime: 2023-11-24 13:39:37
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from '@/store'
import VConsole from 'vconsole'
import waterfall from 'vue-waterfall2'
import VueClipboard from 'vue-clipboard2'
import { Lazyload, NumberKeyboard, PasswordInput, ActionSheet } from 'vant'

import "video.js/dist/video-js.css";
import 'vant/lib/icon/local.css';
import '@/assets/styles/globe.scss'
import {
  getUserInfoSuccess,
  getAppVerInfoSuccess,
  receiveGetInfo,
  loginSuccess,
  setMargins,
  uploadImgSuccess,
  templateInstallAndOpenCallBack,
  queryBrushesComplete,
  installNewBrushSuccess
} from "@/assets/js/client"

Vue.use(waterfall)
Vue.use(VueClipboard)
Vue.use(Lazyload)
Vue.use(NumberKeyboard)
Vue.use(PasswordInput)
Vue.use(ActionSheet)

// const vConsole = new VConsole();
if (process.env.VUE_APP_NODE_ENV == 'development') {
const vConsole = new VConsole();
  // axios.defaults.baseURL = "//test.pandapaint.net/index.php/api";
  // axios.defaults.baseURL = "//app.huashijie.art/index.php/api";
}
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

// request interceptor
axios.interceptors.request.use(
  config => {
    // do something before request is sent
    let baseQuery = store.getters.getQuery
    if (config.method.toLowerCase() === 'post') {
      config.data = {
        ...baseQuery,
        ...config.data
      };
    } else if (config.method.toLowerCase() === 'get') {
      config.params = {
        ...baseQuery,
        ...config.params
      };
    }

    return config;
  }
);

Vue.prototype.$axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 挂载方法到window对象
window.getUserInfoSuccess = getUserInfoSuccess
window.getAppVerInfoSuccess = getAppVerInfoSuccess
window.receiveGetInfo = receiveGetInfo
window.loginSuccess = loginSuccess
window.setMargins = setMargins
window.templateInstallAndOpenCallBack = templateInstallAndOpenCallBack
window.uploadImgSuccess = uploadImgSuccess
window.queryBrushesComplete = queryBrushesComplete
window.installNewBrushSuccess = installNewBrushSuccess
